/***    Aha.js
 *
 *      Miscellaneous support
 */

var
    Aha = {};

/* TRANS - To make a transparent but clickable area on a canvas, one can set its alpha to Aha.TRANS */
Aha.TRANS = 0.01;

/* CTHRU - A color value, black all-but-transparent */
Aha.CTHRU = 'rgba(0, 0, 0, Aha.TRANS)';

/* CWTHRU - A color value, white all-but-transparent */
Aha.CWTHRU = 'rgba(255, 255, 255, Aha.TRANS)';

/* BLACK - A color value, black opaque */
Aha.BLACK = 'rgba(0, 0, 0, 1.0)';

/** xor - Return whether either both or neither of the inputs are true
 */
Aha.xor =
    function (m, n) {
        return (m && !n) || (!m && n);
    };

/** rand - Return a random integer in the given range, inclusive
 */
Aha.rand =
    function (lo, hi) {
        return lo + Math.floor(Math.random() * (hi + 1 - lo));
    };

/** constrain - Return v, but if v < m return m, and if v > x return x
 */
Aha.constrain =
    function (v, m, x) {
        return Math.max(Math.min(v, x), m);
    };

/** within - Return whether v is between m and x, inclusive
 */
Aha.within =
    function (v, m, x) {
        return v >= m && v <= x;
    };

/** spaceWith - Widen a string with spacing (or a custom string) between each pair of characters.
 *
 *  Because there is no direct way that I know of to space out the letters in Easel (CreateJS) text, this function
 *  provides a workaround based on interpolating Unicode space characters of various widths between each character of
 *  the string to be displayed. A custom space (or any custom string) can be passed in as the sp parameter; however
 *  if sp is in the range 0 to 9, a value from spaces[] is used. The returned value is the str parameter with the
 *  desired sequence inserted between each pair of characters.
 */
Aha.spaceWith =
    function (str, sp) {
        var n = parseInt(sp);
        var spaces = [
            '',         // 0 - no space
            '\u2009',   // 1 - thin (usu. 1/5 em, seems to be 6 in Chrome)
            '\u2002',   // 2 - en (1/2 em) - same in Chrome as FF
            '\u2008',   // 3 - punc (width of '.') -- for hangman, Chrome == 1/3 em, FF == 1/4
            '\u2006',   // 4 - 6 per em - same in Chrome as FF
            '\u2005',   // 5 - 4 per em - ditto
            '\u2004',   // 6 - 3 per em - ditto
            '\u2007',   // 7 - tabular (digit) space -- same as en in FF, wider in Chrome,
            '\u200a',   // 8 - hair - (maybe 12 per em? -- seems to be same in C and F)
            '\u205f'    // 9 - medium mathematical, 4/18 em -- same in C and F
        ];

        /* If sp is a valid index into the spaces array, convert it to the corresponding character string */
        if (!isNaN(n) && n < spaces.length)
            sp = spaces[n];

        /* If sp is a valid index into the spaces array, convert it to the corresponding character string */
        return str.split('').join(sp);
    };


/** segmentsOverlap - Return true if two line segments overlap when projected either to the x or the y axis
 *
 *  The arguments are either the x or y components of the endpoints of the two lines
 *  For example, given the lines (x1,y1 to x2,y2) and (x3,y3 to x4,y4), either of the
 *  following might be called: SegmentsOverlap(x1,x2,x3,x4) or SegmentsOverlap(y1,y2,y3,y4)
 *  This function is called by Aha.linesIntersect.
 */
Aha.segmentsOverlap =
    function (a1, a2, b1, b2) {
        var t;

        if (a1 > a2) {
            t = a1;
            a1 = a2;
            a2 = t;
        }

        if (b1 > b2) {
            t = b1;
            b1 = b2;
            b2 = t;
        }

        return (a1 <= b2) && (a2 >= b1);
    };

/** linesIntersect - Return true if the line segments defined by the supplied point objects intersect
 */
Aha.linesIntersect =
    function (p1a, p1b, p2a, p2b) {
        var
            bHorzp, bVertp, bHorzq, bVertq,
            dxp, dyp, dxq, dyq,
            a, b, c, d;

        if (!Aha.segmentsOverlap(p1a.x, p1b.x, p2a.x, p2b.x) || !Aha.segmentsOverlap(p1a.y, p1b.y, p2a.y, p2b.y))
            return false;

        dxp = p1b.x - p1a.x;
        dyp = p1b.y - p1a.y;
        dxq = p2b.x - p2a.x;
        dyq = p2b.y - p2a.y;

        bHorzp = dyp == 0;
        bVertp = dxp == 0;
        bHorzq = dyq == 0;
        bVertq = dxq == 0;

        if (bHorzp || bVertp || bHorzq || bVertq) {
            if (bHorzp && bHorzq) {
                return p1a.y == p2a.y;
            }
            else if (bVertp && bVertq) {
                return p1a.x == p2a.x;
            }
            else if ((bVertp && bHorzq) || (bHorzp && bVertq)) {
                return true;
            }
            else {
                if (bHorzq || bVertq) {
                    if (bHorzq) {
                        a = p1a.x + (dxp * (p2a.y - p1a.y)) / dvp;
                        return Aha.xor(a >= p2a.x, a > p2b.x);
                    }
                    else {
                        a = p1a.y + (dyp * (p2a.x - p1a.x)) / dxp;
                        return Aha.xor(a >= p2a.y, a > p2b.y);
                    }
                }
                else {
                    if (bHorzp) {
                        a = p2a.x + (dxq * (p1a.y - p2a.y)) / dyq;
                        return Aha.xor(a >= p1a.x, a > p1b.x);
                    }
                    else {
                        a = p2a.y + (dyq * (p1a.x - p2a.x)) / dxq;
                        return Aha.xor(a >= p1a.y, a > p1b.y);
                    }
                }
            }
        }
        else {
            a = (dxp * p1a.y) - (dyp * p1a.x);
            b = (dxq * p2a.y) - (dyq * p2a.x);
            c = dxq * a - dxp * b;
            d = (dxp * dyq) - (dxq * dyp);

            return Aha.segmentsOverlap(c, c, p1a.x * d, p1b.x * d) && Aha.segmentsOverlap(c, c, p2a.x * d, p2b.x * d);
        }
    };

/** cloneSimpleObject - Return a copy of (not a reference to) the data object ob
 */
Aha.cloneSimpleObject =
    function (ob) {
        return JSON.parse(JSON.stringify(ob));
    };

/** mergeFields - Merge an object of defaults into another object, and return a reference to the latter
 */
Aha.mergeFields =
    function (o, oDef) {
        if (!Aha.empty(oDef))
            for (var k in oDef) {
                if (oDef.hasOwnProperty(k))
                    o[k] = oDef[k];
            }

        return o;
    };

/** put - Set the x, y, and name properties of the given object, which is expected to be a createjs DisplayObject.
 *  Generate the asset name if none is given. Return the object for chaining.
 */
Aha.put =
    function (o, x, y, assetName) {
        o.x = x;
        o.y = y;
        o.name = assetName || ('Game.put(' + x + ',' + y + ')');

        return o;
    };

/** putText - Set the x, y, and name properties of the given text object, adjusting the y value appropriately for Firefox
 *  if it is in use. Generate the asset name if none is given. Return the object for chaining.
 */
Aha.putText =
    function (o, x, y, assetName) {
        o.x = x;
        o.y = thisGame.gTxY ? thisGame.gTxY(y, assetName) : y;
        o.name = assetName || ('Game.put(' + x + ',' + y + ')');

        return o;
    };

/** offset - Given an object with x and y properties, return the same object offset by dx and dy
 */
Aha.offset =
    function (o, dx, dy) {
        o.x += dx;
        o.y += dy;
        return o;
    };

/** wipeLocalStorage - Remove from browser local storage the data associated with the tags in the given array
 */
Aha.wipeLocalStorage =
    function (tags) {
        for (var i = 0; i < tags.length; i++)
          localStorage.removeItem(tags[i]);
    };

/** empty - Return whether the given value is either null or undefined
 */
Aha.empty =
    function (value) {
        return value === null || value === undefined;
    };

Aha.isMobile = {
    windows: function() {
        return /IEMobile/i.test(navigator.userAgent);
    },
    android: function() {
        return /Android/i.test(navigator.userAgent);
    },
    blackBerry: function() {
        return /BlackBerry/i.test(navigator.userAgent);
    },
    iOS: function() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    },
    any: function() {
        return (isMobile.android() || isMobile.blackBerry() || isMobile.iOS() || isMobile.windows());
    }
};

